import { pointInPolygon } from 'features/Responder/features/Zones';
import { distanceMeters, normalizeGeometryPoints, resolveStopLatLng } from './geo';

export const CHECKPOINT_PROXIMITY_METERS = 30;
export const DESTINATION_PROXIMITY_METERS = 40;

const getCheckpointRadius = (checkpoint) => {
  const geometry = checkpoint?.geometry || {};
  const radius = Number(
    geometry?.radiusMeters ?? checkpoint?.radiusMeters ?? geometry?.radius ?? checkpoint?.radius,
  );
  return Number.isFinite(radius) && radius > 0 ? radius : null;
};

export const isAtCheckpoint = (position, checkpoint) => {
  if (!position || !checkpoint) return false;
  const geometry = checkpoint?.geometry || {};
  const type = (
    geometry?.type ||
    geometry?.kind ||
    checkpoint?.geometryType ||
    checkpoint?.shapeType ||
    checkpoint?.shapeMode ||
    ''
  )
    .toString()
    .toLowerCase();
  const isZoneLike =
    geometry?.isZone ||
    type === 'zone' ||
    type === 'polygon' ||
    geometry?.zoneId != null ||
    checkpoint?.zoneId != null;
  const points = normalizeGeometryPoints(geometry);
  if (isZoneLike && points.length >= 3) {
    return pointInPolygon(position, points);
  }
  const center = resolveStopLatLng(checkpoint);
  if (!center) return false;
  const radius = getCheckpointRadius(checkpoint);
  if (radius) return distanceMeters(position, center) <= radius;
  return distanceMeters(position, center) <= CHECKPOINT_PROXIMITY_METERS;
};


